var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("article", { staticClass: "card", class: { closed: !_vm.open } }, [
    _c(
      "a",
      {
        staticClass: "link",
        attrs: { href: _vm.url },
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.goToMenu()
          },
        },
      },
      [
        _c("div", { staticClass: "image-wrapper" }, [
          _c("img", {
            staticClass: "image lozad",
            attrs: {
              "data-src": _vm.$CDN + _vm.image.imageUrl,
              alt: _vm.image.imageAlt,
              width: "185",
              height: "125",
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "title-wrapper" }, [
            _c("h3", { staticClass: "title" }, [_vm._v(_vm._s(_vm.name))]),
            _vm._v(" "),
            !_vm.open
              ? _c("span", { staticClass: "closed-sign" }, [
                  _c("span", { staticClass: "inner" }, [_vm._v("Closed")]),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "ul",
            {
              class: _vm.distance
                ? "category-list"
                : "category-list-without-address",
            },
            _vm._l(_vm.categories, function (category, i) {
              return _c("li", { key: i, staticClass: "category" }, [
                _vm._v("\n          " + _vm._s(category)),
                i < _vm.categories.length - 1
                  ? _c("span", [_vm._v(",")])
                  : _vm._e(),
              ])
            }),
            0
          ),
          _vm._v(" "),
          _vm.distance
            ? _c("div", { staticClass: "distance-from-address" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.distance) + " Miles Away\n      "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("ul", { staticClass: "details" }, [
            _c(
              "li",
              { staticClass: "detail" },
              [
                _vm.open
                  ? _c(
                      "icon-base",
                      {
                        staticClass: "detail-icon",
                        attrs: {
                          width: "17",
                          height: "17",
                          iconName: "Open Now",
                          id: "openNow" + _vm.restId,
                        },
                      },
                      [_c("icon-check")],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.open
                  ? _c(
                      "icon-base",
                      {
                        staticClass: "detail-icon",
                        attrs: {
                          width: "17",
                          height: "17",
                          iconName: "Closed Now",
                          id: "closedNow" + _vm.restId,
                        },
                      },
                      [_c("icon-clock")],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.open ? _c("span", [_vm._v("Open Now")]) : _vm._e(),
                _vm._v(" "),
                !_vm.open
                  ? _c("span", [_vm._v(_vm._s(_vm.getOpenTime(_vm.openTime)))])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _vm.open && _vm.waitTime
              ? _c(
                  "li",
                  { staticClass: "detail" },
                  [
                    _c(
                      "icon-base",
                      {
                        staticClass: "detail-icon",
                        attrs: {
                          width: "17",
                          height: "17",
                          iconName: "Delivery Estimate",
                          id: "deliveryEstimate" + _vm.restId,
                        },
                      },
                      [_c("icon-clock")],
                      1
                    ),
                    _vm._v(
                      "\n          Estimate: " +
                        _vm._s(_vm.waitTime) +
                        " minutes\n        "
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("li"),
            _vm._v(" "),
            _vm.acceptsDelivery
              ? _c(
                  "li",
                  { staticClass: "detail" },
                  [
                    _c(
                      "icon-base",
                      {
                        staticClass: "detail-icon",
                        attrs: {
                          width: "17",
                          height: "17",
                          iconName: "Delivery",
                          id: "delivery" + _vm.restId,
                        },
                      },
                      [_c("icon-car")],
                      1
                    ),
                    _vm._v(" "),
                    _vm.deliveryFee
                      ? _c("span", [
                          _vm._v("$" + _vm._s(_vm.deliveryFee.trim())),
                        ])
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.acceptsPickup
              ? _c(
                  "li",
                  { staticClass: "detail" },
                  [
                    _c(
                      "icon-base",
                      {
                        staticClass: "detail-icon",
                        attrs: {
                          width: "17",
                          height: "17",
                          iconName: "Pickup",
                          id: "pickup" + _vm.restId,
                        },
                      },
                      [_c("icon-bag")],
                      1
                    ),
                    _vm._v("\n          Pickup\n        "),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }